// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2_USN","colCheckbox":"styles_colCheckbox__O4c35"};